import Button from '@mui/material/Button/Button';
import Dialog from '@mui/material/Dialog/Dialog';
import DialogActions from '@mui/material/DialogActions/DialogActions';
import DialogContent from '@mui/material/DialogContent/DialogContent';
import DialogTitle from '@mui/material/DialogTitle/DialogTitle';
import IconButton from '@mui/material/IconButton/IconButton';
import LinkIcon from '@mui/icons-material/Link';
import React, { useState } from 'react';

import QrCodeScannerIcon from '@mui/icons-material/QrCodeScanner';
import QRCode from 'react-qr-code';
import Stack from '@mui/material/Stack';

export const QRContainer = () => {
    const url = window.location.href;
    const [copied, setCopied] = useState(false);
    return <Stack direction="column" spacing={2}>
        <QRCode value={url} />
        <Button startIcon={<LinkIcon />} variant="text"
            onClick={() => {
                navigator.clipboard.writeText(url);
                setCopied(true);
                setTimeout(() => setCopied(false), 2000);
            }}>
            {copied ? 'Copied!' : 'Copy Link'}
        </Button>
    </Stack>;

};

export const QRCodeDialog = () => {

    const [qrDialogOpen, setQRDialogOpen] = useState(false);

    return (
        <>
            <IconButton title={'Show QR Code'} onClick={() => {
                setQRDialogOpen(true);
            }}><QrCodeScannerIcon /></IconButton>
            <Dialog open={qrDialogOpen} onClose={() => {
                setQRDialogOpen(false);
            }}>
                <DialogContent>
                    <QRContainer />
                </DialogContent>
            </Dialog>
        </>
    );
};
